// const Swiper = (<any>window).Swiper;

// const onlyMobileSingleElementSwiper = (container: HTMLElement) => {
//   const swiperContainer = container.querySelector(".swiper");
//   const pagination = container.querySelector(".swiper-pagination");
//   let swiper = initSwiper();

//   function initSwiper() {
//     return new Swiper(swiperContainer, {
//       loop: true,
//       slidesPerView: 1, // Default for mobile
//       spaceBetween: 10, // Set a default spacing
//       breakpoints: {
//         // when window width is >= 768px (Tablets)
//         768: {
//           slidesPerView: 2,
//           spaceBetween: 20,
//         },
//       },
//       // If we need pagination
//       pagination: {
//         el: pagination,
//         clickable: true,
//       },
//     });
//   }

//   function destroySwiper() {
//     if (swiper) {
//       swiper.destroy(true, true);
//       swiper = null;
//     }
//   }

//   function handleResize() {
//     console.log(window.innerWidth);
//     if (window.innerWidth >= 1024) {
//       // 1024px is the 'lg' breakpoint in Tailwind
//       destroySwiper();
//     } else if (!swiper) {
//       swiper = initSwiper();
//     }
//   }

//   handleResize();
//   window.addEventListener("resize", handleResize);
// };

// const fullSwiper = (container: HTMLElement) => {
//   const swiperContainer = container.querySelector(".swiper-container");
//   const nextEl = container.querySelector(".swiper-button-n");
//   const prevEl = container.querySelector(".swiper-button-p");
//   const pagination = container.querySelector(".swiper-pagination");

//   const swiper = new Swiper(swiperContainer, {
//     loop: true,
//     autoHeight: true,
//     pagination: {
//       el: pagination,
//       clickable: true,
//     },
//     navigation: {
//       nextEl: nextEl,
//       prevEl: prevEl,
//     },
//     slidesPerView: 1, // Default for mobile
//     spaceBetween: 10, // Set a default spacing

//     breakpoints: {
//       // when window width is >= 768px (Tablets)
//       768: {
//         autoHeight: false,
//         slidesPerView: 2,
//         spaceBetween: 20,
//       },
//       // when window width is >= 1024px (Desktops)
//       1024: {
//         autoHeight: false,
//         slidesPerView: 3,
//         spaceBetween: 24,
//       },
//     },
//   });
// };

// document.addEventListener("DOMContentLoaded", function () {
//   fullSwiper(document.querySelector<HTMLElement>("#reviews")!);
//   fullSwiper(document.querySelector<HTMLElement>("#recommendations")!);
//   onlyMobileSingleElementSwiper(
//     document.querySelector<HTMLElement>("#therapists")!
//   );
//   onlyMobileSingleElementSwiper(
//     document.querySelector<HTMLElement>("#problems")!
//   );
// });

const Swiper = (<any>window).Swiper;

const initSwiper = (container: HTMLElement, config: any) => {
  const swiperContainer = container.querySelector(".swiper");
  if (!swiperContainer) return null; // Проверка на наличие контейнера

  const pagination = container.querySelector(".swiper-pagination");

  return new Swiper(swiperContainer, {
    ...config,
    pagination: {
      el: pagination,
      clickable: !config.useProgressBar, // Прогресс-бар не кликабельный
      type: config.useProgressBar ? "progressbar" : "bullets", // Если нужен прогресс-бар, меняем тип пагинации
    },
  });
};

const onlyMobileSingleElementSwiper = (container: HTMLElement) => {
  if (!container) return; // Проверка на наличие контейнера
  let swiper: any = null;

  const handleResize = () => {
    if (window.innerWidth >= 1024) {
      // Ширина экрана >= 1024px — уничтожаем слайдер
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    } else if (!swiper) {
      // Ширина экрана < 1024px — инициализируем слайдер, если его нет
      swiper = initSwiper(container, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
      });
    }
  };

  handleResize();
  window.addEventListener("resize", handleResize);
};

const fullSwiper = (
  container: HTMLElement,
  useProgressBar = false,
  isColleagues: boolean = false
) => {
  if (!container) return; // Проверка на наличие контейнера

  const swiperContainer = container.querySelector(".swiper-container");
  if (!swiperContainer) return; // Проверка на наличие контейнера

  new Swiper(swiperContainer, {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: container.querySelector(".swiper-pagination"),
      clickable: !useProgressBar, // Если используется прогресс-бар, делаем его некликабельным
      type: useProgressBar ? "progressbar" : "bullets", // Прогресс-бар для коллег
    },
    navigation: {
      nextEl: container.querySelector(".swiper-button-n"),
      prevEl: container.querySelector(".swiper-button-p"),
    },
    breakpoints: {
      768: {
        autoHeight: false,
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        autoHeight: false,
        slidesPerView: isColleagues ? 2 : 3, // Если isColleagues - показываем 2 слайда, иначе 3
        spaceBetween: 24,
      },
    },
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const reviewsElement = document.querySelector<HTMLElement>("#reviews");
  const recommendationsElement =
    document.querySelector<HTMLElement>("#recommendations");
  const reviewsColleaguesElement =
    document.querySelector<HTMLElement>("#reviewsColleagues");
  const therapistsElement = document.querySelector<HTMLElement>("#therapists");
  const problemsElement = document.querySelector<HTMLElement>("#problems");

  // Инициализация слайдеров только если элементы существуют
  if (reviewsElement) fullSwiper(reviewsElement);
  if (recommendationsElement) fullSwiper(recommendationsElement);
  if (reviewsColleaguesElement)
    fullSwiper(reviewsColleaguesElement, true, true); // Прогресс-бар и 2 слайда на десктопе
  if (therapistsElement) onlyMobileSingleElementSwiper(therapistsElement);
  if (problemsElement) onlyMobileSingleElementSwiper(problemsElement);
});
